import { Component, ElementRef, HostListener, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';

import * as echarts from 'echarts/core';
import { GridComponent, GridComponentOption } from 'echarts/components';
import { BarChart, BarSeriesOption } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { SimpleChartBar } from 'src/app/Interfaces/Admin/charts/SimpleCharBar.interface';

interface DataYBar {
  value: number,
  itemStyle: colorBar
}

interface colorBar {
  color: string
}

@Component({
    selector: 'app-simple-chart-barrc',
    templateUrl: './simple-chart-barrc.component.html',
    styleUrls: ['./simple-chart-barrc.component.scss', '../../../../Components/Styles/GlobalStyles.css'],
    standalone: false
})

export class SimpleChartBarrcComponent implements OnInit, OnChanges {

  //+===================== INPUTS =====================+\\
  @Input() DataChartBar!: SimpleChartBar;

  //+================== VARIABLES FOR CHART ==================+\\
  @ViewChild('simpleBarChart', { static: true }) chartContainer!: ElementRef;

  private MyChart!: echarts.ECharts;

  ngOnInit(): void {
    echarts.use([GridComponent, BarChart, CanvasRenderer]);

    this.MyChart = echarts.init(this.chartContainer.nativeElement);
    this.updateChart();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['DataChartBar'] && !changes['DataChartBar'].firstChange) {
      this.updateChart();
    }
  }

  private getChartOptions() {

    var option;

    const color: string[] = ['#147496', '#1785AD', '#188FBA', '#1B9DCC', '#1CA5D6', '#21AEEB', '#24BDFF', '#24D5FF', '#24FAFF', '#3CFFFF', '#7BFFFF', '#AEFFFF', '#C8FFFF', '#072834', '#0B3F52', '#0F5A75', '#147496', '#1785AD', '#188FBA', '#1B9DCC', '#1CA5D6', '#21AEEB', '#24BDFF', '#24D5FF', '#24FAFF', '#3CFFFF', '#7BFFFF', '#AEFFFF', '#C8FFFF'];
    const dataBarsY: DataYBar[] = this.DataChartBar.DataY.map((Y: number, index: number) => {
      return { value: Y, itemStyle: { color: color[index % color.length] } }
    })

    option = {
      title: {
        left: 'center',
        text: this.DataChartBar.Title,
      },
      xAxis: {
        type: 'category',
        data: this.DataChartBar.DataX
      },
      yAxis: {
        type: 'value',
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      series: [
        {
          data: dataBarsY,
          type: 'bar',
          // itemStyle: {
          //   color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          //     { offset: 0, color: '#20a8e1' },
          //     { offset: 0.5, color: '#20a8e1' },
          //     { offset: 1, color: '#24FAFF' }
          //   ])
          // },
          // emphasis: {
          //   itemStyle: {
          //     color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
          //       { offset: 0, color: '#20a8e1' },
          //       { offset: 0.7, color: '#24FAFF' },
          //       { offset: 1, color: '#24FAFF' }
          //     ])
          //   }
          // },
        }
      ]
    };

    return option
  }

  //-================== LOAD CHART OPTIONS AND DATA ==================-\\
  private updateChart(): void {
    const options = this.getChartOptions();
    this.MyChart.resize();
    this.MyChart.setOption(options);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event): void {
    if (this.MyChart) {
      this.MyChart.resize();
    }
  }
}
